import React, { useRef } from 'react';
import Slider from 'react-slick';
import Typography from '../../../components/atoms/Typography';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { get } from 'lodash';
import Box from '../../../components/molecules/Box';
import Container from '../../../components/molecules/Container';
import Grid from '../../../components/molecules/Grid';
import clsx from 'clsx';
import 'slick-carousel/slick/slick.css';
import '../../../../styles/themes/slick-themes.css';
import useStyles from '../../../components/organism/SharedMultiCardcontent/style';
import Hidden from '@material-ui/core/Hidden';
import CarouselCard from '../../../components/molecules/CarouselCard';
import { settings } from './config';
import Button from '../../../components/atoms/Button';
import { NoSsr } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { pushAnaylyticsData } from '../../../../../src/utils/analytics';
import { analyticsData } from '../../../../../src/constants/Analytics/analytics-data';
import { EVENT_TYPE } from '../../../../constants/index';
import useStyleOfComponent from './style';
import aspectRatios from '../../../utils/AspectRatios';
import { createDynamicLabels } from '../../../../utils/analytics';

const SharedSimilarSearchContent = props => {
  const {
    cardList,
    title,
    description,
    ctaLink,
    variation,
    pageContentType,
    aspectRatioNeeded = false,
    pageName,
    forcedRatio,
    componentName,
  } = get(props, 'fields', '');
  const { ratio = '3x2-card' } = props;
  let configSettings = { ...settings };

  const { hasFavouriteBasket = false } = props;

  const btnText = get(description, 'value', '');
  const classes = useStyles(props);
  const componentClasses = useStyleOfComponent({ pageContentType });
  const theme = useTheme();
  const isRTL = theme && theme.direction === 'rtl';
  const sharedSimilarSearchWrapper = useRef(null);

  configSettings = {
    ...settings,
    rtl: isRTL,
    initialSlide: isRTL ? 3 : 0,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          initialSlide: isRTL ? cardList && cardList.length - 1 : 0,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '24px',
          arrows: false,
          useTransform: false,
          useCSS: false,
          touchMove: false,
        },
      },
    ],
  };
  const addAnalyticsInfo = () => {
    const obj = {
      ...analyticsData.pageBodyInteraction.arrowClick,
      ...{
        label: createDynamicLabels([
          pageName,
          componentName,
          `${title && title.value} - ${btnText}`,
        ]),
      },
    };
    pushAnaylyticsData(obj);
  };
  const addSwipeAnalyticsInfo = () => {
    const obj = {
      ...analyticsData.pageBodyInteraction.swipeArrowClick,
      ...{
        label: createDynamicLabels([
          pageName,
          componentName,
          `${title && title.value}`,
        ]),
      },
    };
    pushAnaylyticsData(obj);
  };
  const getHeadingContent = () => {
    return (
      <Grid data-locator={props['data-locator']}>
        <div
          className={clsx(
            variation === 'MoreLikeThis' && btnText && classes.descriptionType3
          )}
        >
          {title && title.value && (
            <Typography
              variant="h2"
              className="main-heading"
              component="h2"
              gutterBottom={true}
            >
              <Text field={title} />
            </Typography>
          )}
          {variation === 'MoreLikeThis' && (
            <Hidden mdDown implementation="css">
              {btnText && (
                <Button
                  onClick={addAnalyticsInfo}
                  component="span"
                  buttonType="primary"
                  field={ctaLink}
                >
                  {btnText}
                </Button>
              )}
            </Hidden>
          )}
        </div>
      </Grid>
    );
  };
  // const filteredCardList =
  //   cardList &&
  //   cardList.length > 0 &&
  //   cardList.filter(
  //     item =>
  //       get(item, 'fields.title.value', '') &&
  //       get(item, 'fields.desktopImage.value.src', '')
  //   );

  return (
    <Box
      component="div"
      className={clsx(
        classes.root,
        'Type3', // Because in more like this and other branches both the scenario requires arrow to above of the card unlike on the image
        isRTL && componentClasses.rtlClass,
        componentClasses.root,
        !btnText && 'no-cta'
      )}
      ref={sharedSimilarSearchWrapper}
    >
      <Container>{getHeadingContent()}</Container>
      <NoSsr>
        {cardList && cardList.length > 0 && (
          <Slider
            afterChange={() => addSwipeAnalyticsInfo()}
            {...configSettings}
          >
            {cardList.map(item => {
              return (
                <div
                  key={item}
                  className={
                    !aspectRatioNeeded &&
                      get(item, 'fields.desktopImage.value.src', '') === null ?
                      componentClasses.fallback : ''
                  }
                >
                  <CarouselCard
                    title={get(item, 'fields.title.value', '')}
                    desktopImage={get(item, 'fields.desktopImage', '')}
                    mobileImage={get(item, 'fields.mobileImage', '')}
                    ctaLink={get(item, 'fields.attributeLabelCTA', [])}
                    imageCtaUrl={get(item, 'fields.primaryCTA.value.href', '')}
                    startDate={get(item, 'fields.startDate', '')}
                    locationTitle={get(item, 'fields.locationTitle.value', '')}
                    region={get(item, 'fields.region.value', '')}
                    endDate={get(item, 'fields.endDate', '')}
                    openTime={get(item, 'fields.openTime', '')}
                    closeTime={get(item, 'fields.closeTime', '')}
                    googlePlacesAPI={get(props, 'fields.appConfig.GOOGLE_PLACES_API', '')}
                    umbrellaEventCount={get(
                      item,
                      'fields.umbrellaEventCount',
                      ''
                    )}
                    bgColor={get(item, 'fields.backgroundColor.value', '')}
                    cardType={
                      pageContentType === EVENT_TYPE ? EVENT_TYPE : 'listing'
                    }
                    eventType={get(item, 'fields.eventType', '')}
                    location={get(item, 'fields.location', '')}
                    pageContentType={pageContentType}
                    sectionTitle={title}
                    aspectRatio={aspectRatios[ratio]}
                    aspectRatioNeeded={aspectRatioNeeded}
                    pageName={pageName}
                    componentName={componentName}
                    urlSlug={get(item, 'fields.urlSlug', '')}
                    expenseRange={get(item, 'fields.expenseRange', '')}
                    viewsCount={get(item, 'fields.viewsCount', '')}
                    rating={get(item, 'fields.rating', '')}
                    num_reviews={get(item, 'fields.num_reviews', '')}
                    rating_image_url={get(item, 'fields.rating_image_url', '')}
                    googlePlaceId={get(item, 'fields.googlePlaceId', '')}
                    itemUniqueKey={get(item, 'fields.itemUniqueKey', '')}
                    forcedRatio={forcedRatio}
                    showFavoriteIcon={hasFavouriteBasket}
                  />
                </div>
              );
            })}
          </Slider>
        )}
      </NoSsr>
      {variation === 'MoreLikeThis' && (
        <Hidden lgUp implementation="css">
          {btnText && (
            <Box component="div" px={3}>
              <Button
                onClick={addAnalyticsInfo}
                component="span"
                buttonType="primary"
                field={ctaLink}
              >
                {btnText}
              </Button>
            </Box>
          )}
        </Hidden>
      )}
    </Box>
  );
};

export default SharedSimilarSearchContent;
